module.exports = __webpack_public_path__ + "img/fault-lb.b2832afa.png";